import { render, staticRenderFns } from "./unityDetail.vue?vue&type=template&id=8d71b610&scoped=true"
import script from "./unityDetail.vue?vue&type=script&lang=js"
export * from "./unityDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/unityDetail.scss?vue&type=style&index=0&id=8d71b610&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d71b610",
  null
  
)

export default component.exports